import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { pathTo } from '../../../App/routes';
import { ON_OFF_COURTS, ON_OFF_STATS } from '../on-off-reports';
import { round2 } from '../../../lib/format';

const PlayerRow = ({ player }) => (
  <tr>
    <PlayerHeaderCell player={player} />

    {ON_OFF_COURTS.map(court =>
      ON_OFF_STATS.map(stat => (
        <PlayerStatCell
          key={`${court.court}-${stat.stat}`}
          player={player}
          court={court}
          stat={stat}
        />
      )),
    )}
  </tr>
);

PlayerRow.propTypes = {
  player: PropTypes.object.isRequired,
};

export default PlayerRow;

const PlayerHeaderCell = ({ player }) => (
  <th
    key={player.jersey}
    title={player.normalized}
    className="stats-table__row-title stats-table__row-title--double"
  >
    <Link to={pathTo('player', player.id)} className="s-advanced-stats__player">
      <div className="player__jersey">{player.jersey}</div>
      <div className="player__name">{player.normalized}</div>
    </Link>
  </th>
);

const PlayerStatCell = ({ player, court, stat }) => {
  if (!hasCourtStat(court, stat)) return null;

  return formattedValueCell(player, court, stat);
};

function hasCourtStat(court, stat) {
  return court.stats.indexOf(stat.stat) !== -1;
}

function formattedValueCell(player, court, stat) {
  const value = player[court.court][stat.stat];
  const roundedValue = value && round2(value);
  const highlightClass = stat.highlight ? 'highlight' : '';
  let dangerClass;
  if (court.inverse && court.inverse.includes(stat.stat)) {
    dangerClass = roundedValue && roundedValue < 0 ? '' : 'danger';
  } else {
    dangerClass = roundedValue && roundedValue > 0 ? '' : 'danger';
  }
  const courtClass = `court-${court.court}`;

  return (
    <td className={`${highlightClass} ${dangerClass} ${courtClass}`}>
      {roundedValue}
    </td>
  );
}
